// ─────────────────────────────────────────────────────────────────────────────
// Crew — honest offer labelling (Agent B).
//
// GUARDRAIL: we must NEVER imply a partnership that doesn't exist. The catalogue
// is a curated demo. So affiliate / card-linked offers are labelled plainly, and
// CLO-eligibility is flagged separately. No badge for offerType 'none'.
// ─────────────────────────────────────────────────────────────────────────────

import type { OfferType } from '../lib/types';

export function OfferTag({ offerType, cloEligible }: { offerType: OfferType; cloEligible: boolean }) {
  const tags: { label: string; title: string; className: string }[] = [];

  if (offerType === 'affiliate') {
    tags.push({
      label: 'Affiliate',
      title: 'If you book through this link, Crew may earn a commission at no extra cost to you.',
      className: 'bg-amber-400/20 text-amber-500 ring-amber-400/40',
    });
  } else if (offerType === 'clo') {
    tags.push({
      label: 'Card-linked offer',
      title: 'A reward attached to your existing card via a third-party provider. Crew never issues a card.',
      className: 'bg-amber-500/20 text-amber-500 ring-amber-500/40',
    });
  }

  if (cloEligible) {
    tags.push({
      label: 'CLO-eligible',
      title: 'Eligible for a card-linked reward if you choose to link your existing card (consent-gated).',
      className: 'bg-sand-200 text-ink-700 ring-sand-300',
    });
  }

  if (tags.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map((t) => (
        <span
          key={t.label}
          title={t.title}
          className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold ring-1 ${t.className}`}
        >
          {t.label}
        </span>
      ))}
    </div>
  );
}
